import { ModuleKind } from "src/clients/flow-api";
import { useIsModuleEnabled } from "src/hooks/useIsModuleEnabled";

export const useIsAnalyticsModuleEnabled = (): { isEnabled: boolean } => {
  return useIsModuleEnabled(ModuleKind.ANALYTICS);
};
